<script>
// 親がrelativeなdomに置く
export default {
  name: 'simpleLoading',
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    numOfDot: {
      type: Number,
      default: 5,
    },
    dotRadius: {
      type: Number,
      default: 10,
    },
  },
  created() {
  },
};
</script>

<template>
  <div class="loading">
    <div
      class="i"
      v-for="n of numOfDot"
      :key="n"
      :style="{
        'animation-duration': numOfDot * 0.4 + 's',
        'animation-delay': n * 0.4 + 's',
        width: dotRadius + 'px',
        height: dotRadius + 'px',
        'border-radius': dotRadius / 2 + 'px'
      }"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .loading {
    display: flex;
    justify-content: space-around;
    align-items: center;
    @include absolute100;
    .i {
      background: $textColorA50;
      animation-name: animeLoad;
      animation-timing-function: ease;
      animation-iteration-count: infinite;
    }
  }

  @keyframes animeLoad {
    0%{transform: scale(1); background: $textColorA50;}
    50%{transform: scale(1.5); background: $accentColor2A50;}
    100%{transform: scale(1); background: $textColorA50;}
  }
</style>
